export const VP_MOBILE_BREAKPOINT = 1000;

export class VpModel {
  isDesktop: boolean;
  isMobile: boolean;
  winHeight: number;
  winWidth: number;
}
